import React, { FC } from 'react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { observer } from 'mobx-react'
import { payMobx } from '@mobxStore'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: () => void;
}

const CompliancePolicyModal: FC<IProps> = ({ resolve }) => {
  return (
    <IonModal isOpen cssClass='compliance-policy-modal'>
      <IonHeader>{i18n.t('pay.policy')}</IonHeader>
      <IonContent>
        <div className='mobile-policy-content' dangerouslySetInnerHTML={{ __html: payMobx.compliancePolicy }} />
      </IonContent>
      <IonFooter className='submit'>
        <button className='pay-button' data-cypid='compliancePolicyModalConfirm' onClick={resolve}>{i18n.t('common.ok')}</button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(CompliancePolicyModal)
